import script from "./ProductSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSelector.vue?vue&type=script&setup=true&lang=js"

import "./ProductSelector.vue?vue&type=style&index=0&id=1731ca62&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1731ca62"]])

export default __exports__